import { ACTIONS } from '../action/actionTypes'

const initialState = {
  available: [
    { code: 'en', title: "English" },
    { code: 'fr', title: "Francais" },
    { code: 'es', title: 'Español' }
  ],
  default: 0
};

export const language = ( state = initialState, action ) => {
  switch ( action.type ) {
    case ACTIONS.SET_AVAILABLE_LANGUAGES:
      console.log({ ...state, available: action.available });
      return { ...state, available: action.available };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducer/language_reducer.js